import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const placeholderColor = '#c3ced9';

const StyledInput = styled.input`
  border: 0;
  outline: none;
  display: block;
  margin: 0;
  width: calc(100% - 44px);
  line-height: 15px;
  border: 2px solid transparent;

  ${({ valid }) => (typeof valid === 'boolean' && valid === false) ? 'color: #f00;' : ''}
  &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &::-moz-placeholder { /* Firefox 19+ */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &:-ms-input-placeholder { /* IE 10+ */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &:-moz-placeholder { /* Firefox 18- */
    color: ${placeholderColor};
    font-weight: normal;
  }
  &::placeholder {
    color: ${placeholderColor};
    font-weight: normal;
  }
  &:-moz-read-only { /* For Firefox */
    cursor: not-allowed;
    background-color: white !important;
  }
  &:read-only {
    cursor: not-allowed;
    background-color: white !important;
  }
`;

class GuestInput extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    htmlId: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onMove: PropTypes.func,
    className: PropTypes.string,
    validate: PropTypes.func,
    mapValue: PropTypes.shape({
      in: PropTypes.func, // from store to state
      out: PropTypes.func, // from state to store
    }),
    title: PropTypes.func,
    shouldFocus: PropTypes.bool,
    readonly: PropTypes.bool,
    setRequiredField: PropTypes.func,
    unsetRequiredField: PropTypes.func,
    setValidationError: PropTypes.func,
    unsetValidationError: PropTypes.func,
    nonRequired: PropTypes.bool,
    field: PropTypes.string,
  };
  static defaultProps = {
    type: 'text',
    value: '',
    onChange: () => {},
    onBlur: () => {},
    onMove: () => {},
    mapValue: {
      in: v => v,
      out: v => v,
    },
    validate: () => true,
    nonRequired: false,
  };

  constructor(props) {
    super(props);
    this.previousValue = props.value;
    this.state = {
      value: this.props.mapValue.in(props.value) || '',
      hasFocus: false,
    };
  }

  componentWillReceiveProps({ value: nextValue }) {
    const mappedValue = this.props.mapValue.in(nextValue);
    if (mappedValue !== this.state.value) {
      this.setState({ value: mappedValue, valid: true });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextState.value !== this.state.value || nextState.valid !== this.state.valid || !!nextProps.shouldFocus;
  }

  componentDidUpdate = () => {
    if (this.props.shouldFocus && this.state.hasFocus === false) {
      this.el.focus();
      this.el.select();
    }
  }

  onFocus = () => {
    this.setState({ hasFocus: true });
    this.props.onFocus();
    this.el.select();
  }

  onBlur = () => {
    const { onBlur } = this.props;

    this.setState({ hasFocus: false });
    this.checkForChanges();
    onBlur();
  }

  onChange = (event) => {
    const { nonRequired, field } = this.props;
    const value = event.target.value;
    const valid = this.props.validate(value, field);

    if (!valid) {
      this.props.setValidationError();
    } else {
      this.props.unsetValidationError();
    }

    if (value.length === 1 && !nonRequired) {
      this.props.unsetRequiredField();
    } else if (value.length <= 0 && !nonRequired) {
      this.props.setRequiredField();
    }
    this.setState({ value, valid });
  }

  onMove = (direction) => {
    const { onMove } = this.props;
    this.checkForChanges();
    onMove(direction);
  }

  onKeyDown = (event) => {
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.onMove(1);
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.onMove(-1);
        break;
      default:
        break;
    }
  }

  checkForChanges = () => {
    const { value: currentValue, valid } = this.state;
    const { onChange, mapValue } = this.props;
    if (currentValue !== this.previousValue && valid) {
      const outValue = mapValue.out(currentValue);
      const reformattedValue = mapValue.in(outValue);
      if (this.previousValue === reformattedValue) {
        // restore value to a correctly formatted value
        this.setState({ value: reformattedValue });
      } else {
        // value has changed, trigger onChange
        this.previousValue = reformattedValue;
        onChange(outValue);
      }
    }
  }

  previousValue = '';

  ref = (el) => {
    this.el = el;
  }

  render() {
    const { value, valid } = this.state;
    const { type, placeholder, htmlId, className, title, readonly } = this.props;

    return (
      <StyledInput
        innerRef={this.ref}
        id={htmlId}
        className={className}
        type={type}
        placeholder={placeholder}
        value={value}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onChange={this.onChange}
        onKeyDown={this.onKeyDown}
        readOnly={readonly}
        valid={valid}
        title={title}
      />
    );
  }
}

export default GuestInput;



// WEBPACK FOOTER //
// ./src/components/molecules/GuestInput/index.js